import { ReactComponent as ClassCode } from './icon_class_code.svg';
import Icon, { IconProps } from './icon';

const IconClassCode = (props: IconProps) => {
  return <Icon {...props} Svg={ClassCode} />;
};

export default IconClassCode;
